import { useState } from "react";
import { supabase } from "../lib/supabase";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError("Correo o contraseña incorrectos");
    setLoading(false);
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{ width: "100%", maxWidth: 400, padding: "0 24px" }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            <span style={{ fontSize: 40, fontWeight: 800, color: "#29abe2", letterSpacing: -2 }}>tu</span>
            <span style={{ fontSize: 40, fontWeight: 800, color: "#0d1117", letterSpacing: -2 }}>aplicacion</span>
          </div>
          <div style={{ fontSize: 10, letterSpacing: 4, color: "#94a3b8", textTransform: "uppercase", marginTop: 4 }}>
            desarrollo de software
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: 16,
          padding: "36px 32px",
          boxShadow: "0 4px 24px #0000000a",
        }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#0d1117", marginBottom: 6 }}>
            Iniciar sesión
          </h2>
          <p style={{ color: "#94a3b8", fontSize: 13, marginBottom: 28 }}>
            Ingresa tus credenciales para continuar
          </p>

          <form onSubmit={handleLogin}>
            {/* Email */}
            <div style={{ marginBottom: 18 }}>
              <label style={{
                display: "block", fontSize: 12, fontWeight: 600,
                color: "#374151", marginBottom: 7,
              }}>
                Correo electrónico
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="ivan@tuaplicacion.cl"
                required
                style={{
                  width: "100%", padding: "12px 14px",
                  background: "#f8fafc", border: "1.5px solid #e2e8f0",
                  borderRadius: 8, color: "#0d1117", fontSize: 14,
                  fontFamily: "inherit", outline: "none",
                  boxSizing: "border-box", transition: "all .2s",
                }}
                onFocus={e => {
                  e.target.style.borderColor = "#29abe2";
                  e.target.style.background = "#fff";
                  e.target.style.boxShadow = "0 0 0 3px #29abe215";
                }}
                onBlur={e => {
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.background = "#f8fafc";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Password */}
            <div style={{ marginBottom: 24 }}>
              <label style={{
                display: "block", fontSize: 12, fontWeight: 600,
                color: "#374151", marginBottom: 7,
              }}>
                Contraseña
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={{
                  width: "100%", padding: "12px 14px",
                  background: "#f8fafc", border: "1.5px solid #e2e8f0",
                  borderRadius: 8, color: "#0d1117", fontSize: 14,
                  fontFamily: "inherit", outline: "none",
                  boxSizing: "border-box", transition: "all .2s",
                }}
                onFocus={e => {
                  e.target.style.borderColor = "#29abe2";
                  e.target.style.background = "#fff";
                  e.target.style.boxShadow = "0 0 0 3px #29abe215";
                }}
                onBlur={e => {
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.background = "#f8fafc";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Error */}
            {error && (
              <div style={{
                background: "#fef2f2", border: "1px solid #fecaca",
                borderRadius: 8, padding: "10px 14px",
                color: "#dc2626", fontSize: 13, marginBottom: 18,
              }}>
                ⚠ {error}
              </div>
            )}

            {/* Botón */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%", padding: "13px",
                background: loading ? "#29abe280" : "#29abe2",
                border: "none", borderRadius: 8,
                color: "#fff", fontSize: 14, fontWeight: 700,
                fontFamily: "inherit", cursor: loading ? "not-allowed" : "pointer",
                transition: "all .2s",
                boxShadow: loading ? "none" : "0 4px 12px #29abe230",
              }}
              onMouseEnter={e => { if (!loading) e.currentTarget.style.background = "#1a9fd4"; }}
              onMouseLeave={e => { if (!loading) e.currentTarget.style.background = "#29abe2"; }}
            >
              {loading ? "Ingresando..." : "Ingresar"}
            </button>
          </form>
        </div>

        <p style={{ textAlign: "center", color: "#cbd5e1", fontSize: 11, marginTop: 24 }}>
          © 2025 TuAplicacion SpA · Sistema Contable Chile
        </p>
      </div>

      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');`}</style>
    </div>
  );
}